import React from 'react';
import CabPageShell from './CabPageShell';

const AdminCabsReviews = () => (
  <CabPageShell
    title="Reviews"
    description="Moderate customer reviews and ratings."
  />
);

export default AdminCabsReviews;
